module.exports = __webpack_public_path__ + "87b128b87f59695f07d7fb23c1fe2d01.svg";